<template>
  <div v-if="isShow">
      <slot></slot>
  </div>
</template>
<script>
import API from "../../../../service/index";
export default {
  props: {
    custype: {
      type: String,
      default: () => {
        return "";
      },
    },
    year: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    quarter: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    /***
     * type
     * apply 新增删除编辑
     * audit 审核
     */
    auth(type, year, quarter) {
      API.getAuthtoBTN({}).then((res) => {
        // console.log("------按钮里面的权限", res);
        if (res.ret === 0) {
          for (let key in res.data) {
            const yearkey = key.substring(0, key.lastIndexOf("-"));
            const quarterkey = key.substring(key.indexOf("-") + 1, key.length);
            // console.log('-----键值年：', yearkey);
            // console.log('-----键值季度:', quarterkey);
            // console.log('----年:', year);
            // console.log('----季度:', quarter);
            // 传进来的 年 季度 对等，则应该 控制 对等年 季度 的开关
            const roleLevel = JSON.parse(localStorage.getItem('appraiseNewLocalauthority'))
            console.log('res.data[key].audit',roleLevel.roleLevel)
            if (yearkey == year && quarter == quarterkey) {
              if (roleLevel.roleLevel == 1) {
                this.getAuth(res.data[key].audit);
              } else {
                const value = (res.data[key].audit === 'on' && res.data[key].applyArea[this.$route.query.area] === 'on') ? 'on' : 'off';
                this.getAuth(value);
              }
              //  console.log('----应该会打印很多次才对撒');
              // if (type === "apply") {
              //   if (res.data[key].apply === "on") {
              //     this.isShow = true;
              //     return true;
              //   } else {
              //     this.isShow = false;
              //     return false;
              //   }
              // } else if (type === "audit") {
                
              //   if (res.data[key].audit === "on") {
              //     this.isShow = true;
                 
              //     return true;
              //   } else {
              //     this.isShow = true;
              //     return false;
              //   }
              // }
            //   console.log("------值apply：", res.data[key].apply);
            //   console.log("-----值audit：", res.data[key].audit);
            }
          }
        } else {
          console.log("接口返回的值不对");
          return false;
        }
      });
    },
    getAuth(verify) {
      switch(verify) {
        case 'on' :
          this.isShow = true;
          break;
        case 'off' :
          this.isShow = false;
          break;
        default :
        this.isShow = false;
      }
    }
  },
  mounted() {
    this.auth(this.custype, this.year, this.quarter);
  },
};
</script>